import styled, { css } from 'styled-components';

const Button = styled.button`
  height: 32px;
  width: 32px;
  border: none;
  background-color: transparent;
  outline: none;

  ${({ border }) =>
    border &&
    css`
      border-left: 1px solid ${({ theme }) => theme.gray2};
    `};

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${({ theme }) => theme.gray2};
    `};

  :hover:not(:disabled) {
    background-color: ${({ theme }) => theme.gray2};
    cursor: pointer;
  }

  :disabled {
    svg {
      fill: ${({ theme }) => theme.textDisabled};
    }
  }

  svg {
    height: 32px;
    width: auto;
    fill: ${({ theme }) => theme.text};
  }
`;

export default Button;
